import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }

import { ref } from 'vue'
import { getVisLog } from '@/service/main/platform';
import { ElMessage } from 'element-plus';
import { exportJson2Excel, formatJson } from "@/utils/excel";
import Pagination from '@/components/Pagination/index.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const rowClass = (row: any, column: number, rowIndex: number, columnIndex: number) => {
  if (row.rowIndex === 0) {
    return "color: #606266;font-weight: bold;"
  }
}
//查询
const formModel = ref({
  PageNo: 1,
  PageSize: 10,
  Name: '',
  SearchBeginTime: "",
  SearchEndTime: "",
  ReceiveDate: []
});
//仓库类型列表
let tableData = ref([]);
//列表的数据条数
const totalItems = ref<number>(0);
//获取菜单列表
const getTabelData = () => {
  //判断完成时间是否有选择
  if (formModel.value.ReceiveDate.length > 0) {
    formModel.value.SearchBeginTime = formModel.value.ReceiveDate[0];
    formModel.value.SearchEndTime = formModel.value.ReceiveDate[1];
  }
  getVisLog(formModel.value).then(res => {
    const { data } = res;
    tableData.value = data.rows;
    totalItems.value = data.totalRows;
  }).catch(err => {
    ElMessage.error(err)
  })
}
getTabelData();

//重置搜索
const resetForm = () => {
  formModel.value = {
    PageNo: 1,
    PageSize: 10,
    Name: '',
    SearchBeginTime: "",
    SearchEndTime: "",
    ReceiveDate: []
  }
  getTabelData();
}

//选中的行
const checkRows = ref<{ id: number }[]>([]);

// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
}
//导出
const handExport = () => {
  const tHeader: string[] = Object.keys(checkRows.value[0]);
  const data = formatJson(tHeader, checkRows.value);
  exportJson2Excel(
    tHeader,
    data,
    "列表数据"
  );
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "92px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "访问人:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.Name) = $event)),
                        clearable: "",
                        placeholder: "请输入访问人"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "访问时间:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formModel.value.ReceiveDate,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.ReceiveDate) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "YYYY-MM-DD",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        "header-cell-style": rowClass
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "序号",
            type: "index",
            width: "60",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "访问人",
            prop: "name",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "消息",
            prop: "message",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "访问人ip",
            prop: "ip",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "浏览器类型",
            prop: "browser",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作系统",
            prop: "os",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "访问时间",
            prop: "visTime",
            align: "center"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ])
  ], 64))
}
}

})